import { Injectable } from '@angular/core';
import { User, UuidAuthResponse } from '../../models';
import { AbstractStorageService } from '../storage/abstract-storage.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export abstract class AbstractStateService {
  // region scroll behaviour
  private scrollPosition$$: BehaviorSubject<number>;
  public readonly scrollPosition$: Observable<number>;

  private scrollToPosition$$: BehaviorSubject<number>;
  public readonly scrollToPosition$: Observable<number>;

  private scrollToTopSubject: BehaviorSubject<boolean>;
  public readonly scrollToTop$: Observable<boolean>;

  private scrollToEndSubject: BehaviorSubject<boolean>;
  public readonly scrollToEnd$: Observable<boolean>;
  // endregion

  // region user
  private user$$: BehaviorSubject<User>;
  public readonly user$: Observable<User>;
  // endregion

  private mapOfBoIdAndUuidAuthResponse = new Map<number, UuidAuthResponse>();

  constructor(protected storageService: AbstractStorageService) {
    this.scrollPosition$$ = new BehaviorSubject<number>(0);
    this.scrollPosition$ = this.scrollPosition$$.asObservable();

    this.scrollToPosition$$ = new BehaviorSubject<number>(0);
    this.scrollToPosition$ = this.scrollToPosition$$.asObservable();

    this.scrollToTopSubject = new BehaviorSubject<boolean>(false);
    this.scrollToTop$ = this.scrollToTopSubject.asObservable();

    this.scrollToEndSubject = new BehaviorSubject<boolean>(false);
    this.scrollToEnd$ = this.scrollToEndSubject.asObservable();

    this.user$$ = new BehaviorSubject<User>(null);
    this.user$ = this.user$$.asObservable();
  }

  // region token
  public getToken(): string {
    return this.storageService.getAuthToken();
  }

  public setToken(token: string): void {
    if (!token?.length) {
      this.storageService.removeAuthToken();
    } else {
      this.storageService.saveAuthToken(token);
    }
  }
  // endregion

  // region scroll behaviour
  public setScrollPosition(position: number): void {
    this.scrollPosition$$.next(position);
  }

  public setScrollToPosition(position: number): void {
    this.scrollToPosition$$.next(position);
  }

  public setScrollToTop(): void {
    this.scrollToTopSubject.next(true);
  }

  public setScrollToEnd(): void {
    this.scrollToEndSubject.next(true);
  }
  // endregion

  // region user
  public setUser(user: User): void {
    this.user$$.next(user);
  }

  public getUser(): User {
    return this.user$$.value;
  }
  // endregion

  // region mapOfBoIdAndUuidAuthResponse
  public hasUuidAuthResponseForBoId(boId: number): boolean {
    return this.mapOfBoIdAndUuidAuthResponse.has(boId);
  }

  public getUuidAuthResponseForBoId(boId: number): UuidAuthResponse {
    return this.mapOfBoIdAndUuidAuthResponse.get(boId);
  }

  public setUuidAuthResponseForBoId(
    boId: number,
    uuidAuthResponse: UuidAuthResponse
  ): void {
    this.mapOfBoIdAndUuidAuthResponse.set(boId, uuidAuthResponse);
  }

  public getAllSavedBoIdForUuidAuthResponse(): number[] {
    return Array.from(this.mapOfBoIdAndUuidAuthResponse.keys());
  }

  protected clearMapOfBoIdAndUuidAuthResponse(): void {
    this.mapOfBoIdAndUuidAuthResponse.clear();
  }
  // endregion
}
